/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import ErrorBoundary from 'base/components/ErrorBoundary';
import LabradorBox from 'base/components/labrador/Box';

export const DynamicLabradorBox: typeof LabradorBox = (props) => {
    return <ErrorBoundary><LabradorBox {...props} /></ErrorBoundary>;
}
export type DynamicLabradorBoxProps = PropsFromComponent<typeof LabradorBox>;
